export const TRANSLATIONS_EN = {
    call:"Call",
    send:"Send",
    rating:"Rating",
    yourComment:"Your comment",
    thanksForReview:"Thanks for review",
    thanksForCall:"Thank you for using our service",
    yourName:"Your name..",
    yourPhone:"Your phone..",
    serverError:"OOPS! Server's internal error",
    headPhoneError:"Connect headphones with mic and reload the page",
    notAllowedError:"Your browser does not allow access to your microphone",
    missLink:'Current link not found.',
    inactiveLink:'Current link not active.',
    notSupported:'Your browser does not supported WebRTC'
};